import { render, staticRenderFns } from "./ProductSetup.vue?vue&type=template&id=ea7c2162"
import script from "./ProductSetup.vue?vue&type=script&lang=js"
export * from "./ProductSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports